module.exports = __webpack_public_path__ + "img/partner_logo01.f7273e65.png";